import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";
import refetchCollectionQueries from "../utils/refetchCollectionQueries";

/**
 * Runs the marketplace publication pass on demand - the same work the hourly
 * cron does - so a collection scheduled for today goes out immediately.
 */
const usePublishPendingCollectionsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["publish-pending-collections"],
    mutationFn: () => collectionApiClient.publishPendingCollections(),
    onSettled: () => refetchCollectionQueries(queryClient),
  });
};

export default usePublishPendingCollectionsMutation;
